<template>
  <div>
    <v-card
      class="mx-auto ml-5 mr-5 mt-5 mb-5"
      max-width="100%"
      outlined
      v-if="defaultValue.name != ''"
    >
      <div>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">Badan Usaha</div>
            <v-list-item-title class="headline mb-1">
              <v-chip
                label
                color="green darken-2"
                class="mr-1"
                text-color="white"
              >
                <v-avatar left>
                  <v-icon>mdi-domain</v-icon>
                </v-avatar>
                {{ defaultValue.name }}
              </v-chip>
              <v-chip
                label
                color="teal darken-2"
                class="mr-1"
                text-color="white"
                @click="detailInvoice()"
              >
                <v-avatar left>
                  <v-icon>mdi-beaker-outline</v-icon>
                </v-avatar>
                Detail Invoice
              </v-chip>
              <v-chip label color="orange darken-2" text-color="white">
                <v-avatar left>
                  <v-icon>mdi-cash-multiple</v-icon>
                </v-avatar>
                Billing Counter: {{ convertCurrency(billingCounter) }}
              </v-chip>
              <!-- <span style="font-size: 0.8em;"> Billing Counter: {{convertCurrency(billingCounter)}}</span> -->
            </v-list-item-title>
            <v-list-item-subtitle>{{
              defaultValue.description
            }}</v-list-item-subtitle>
            <h5 class="mt-2">Owner Name: {{ defaultValue.owner_name }}</h5>
            <h5 class="mt-2">Company Address:{{ defaultValue.address }}</h5>
            <h5 class="mt-2">NPWP: {{ defaultValue.company_number }}</h5>
            <h5 class="mt-2">Phone: {{ defaultValue.telp }}</h5>
            <h5 class="mt-2 mb-4">Email: {{ defaultValue.email }}</h5>
            <v-divider
              v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
            ></v-divider>
            <h5
              class="mt-2"
              v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
            >
              Lampiran
            </h5>
            <v-col
              cols="12"
              sm="6"
              md="12"
              style="padding: 0px"
              v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
            >
              <v-row>
                <v-col cols="4" sm="2" md="4" style="align-self: center">
                  <span>Foto NPWP</span>
                </v-col>
                <v-col cols="4" sm="2" md="4">
                  <v-file-input
                    accept="image/*,.pdf"
                    label="Upload/Update NPWP"
                    outlined
                    dense
                    hide-details="true"
                    @change="onUploadImageNPWP()"
                    v-model="fileFotoNPWP"
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="4"
                  sm="2"
                  md="4"
                  class="text-center"
                  style="align-self: center"
                >
                  <a v-if="urlNPWP != null" :href="urlNPWP" target="_blank"
                    >LIHAT FOTO NPWP</a
                  ><br />
                  <v-btn
                    text
                    small
                    v-if="urlNPWP != null"
                    @click="onRemoveImage('npwp')"
                    color="error"
                    >Hapus Foto NPWP</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="12"
              style="padding: 0px"
              v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
            >
              <v-row>
                <v-col cols="4" sm="2" md="4" style="align-self: center">
                  <span>Akta</span>
                </v-col>
                <v-col cols="4" sm="2" md="4">
                  <v-file-input
                    accept="image/*,.pdf"
                    label="Upload/Update Akta"
                    outlined
                    dense
                    hide-details="true"
                    @change="onUploadAkta()"
                    v-model="fileAkta"
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="4"
                  sm="2"
                  md="4"
                  class="text-center"
                  style="align-self: center"
                >
                  <a v-if="urlAkta != null" :href="urlAkta" target="_blank"
                    >LIHAT AKTA</a
                  ><br />
                  <v-btn
                    text
                    small
                    v-if="urlAkta != null"
                    @click="onRemoveImage('akta')"
                    color="error"
                    >Hapus Akta</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="12"
              style="padding: 0px"
              v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
            >
              <v-row>
                <v-col cols="4" sm="2" md="4" style="align-self: center">
                  <span>SIUP</span>
                </v-col>
                <v-col cols="4" sm="2" md="4">
                  <v-file-input
                    accept="image/*,.pdf"
                    label="Upload/Update SIUP"
                    outlined
                    dense
                    hide-details="true"
                    @change="onUploadSIUP()"
                    v-model="fileSIUP"
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="4"
                  sm="2"
                  md="4"
                  class="text-center"
                  style="align-self: center"
                >
                  <a v-if="urlSIUP != null" :href="urlSIUP" target="_blank"
                    >LIHAT SIUP</a
                  ><br />
                  <v-btn
                    text
                    small
                    v-if="urlSIUP != null"
                    @click="onRemoveImage('siup')"
                    color="error"
                    >Hapus SIUP</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="12"
              style="padding: 0px"
              v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
            >
              <v-row>
                <v-col cols="4" sm="2" md="4" style="align-self: center">
                  <span>TDP</span>
                </v-col>
                <v-col cols="4" sm="2" md="4">
                  <v-file-input
                    accept="image/*,.pdf"
                    label="Upload/Update TDP"
                    outlined
                    dense
                    hide-details="true"
                    @change="onUploadTDP()"
                    v-model="fileTDP"
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="4"
                  sm="2"
                  md="4"
                  class="text-center"
                  style="align-self: center"
                >
                  <a v-if="urlTDP != null" :href="urlTDP" target="_blank"
                    >LIHAT TDP</a
                  ><br />
                  <v-btn
                    text
                    small
                    v-if="urlTDP != null"
                    @click="onRemoveImage('tdp')"
                    color="error"
                    >Hapus TDP</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="12"
              style="padding: 0px"
              v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
            >
              <v-row>
                <v-col cols="4" sm="2" md="4" style="align-self: center">
                  <span>Company Profile</span>
                </v-col>
                <v-col cols="4" sm="2" md="4">
                  <v-file-input
                    accept="image/*,.pdf"
                    label="Upload/Update CP"
                    outlined
                    dense
                    hide-details="true"
                    @change="onUploadCompanyProfile()"
                    v-model="fileCompanyProfile"
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="4"
                  sm="2"
                  md="4"
                  class="text-center"
                  style="align-self: center"
                >
                  <a
                    v-if="urlCompanyProfile != null"
                    :href="urlCompanyProfile"
                    target="_blank"
                    >LIHAT COMPANY PROFILE</a
                  ><br />
                  <v-btn
                    text
                    small
                    v-if="urlCompanyProfile != null"
                    @click="onRemoveImage('company profile')"
                    color="error"
                    >Hapus Company Profile</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <span class="pt-2" style="color: red">*max filesize 1 MB</span>
          </v-list-item-content>

          <template
            v-if="role == 'accountant' || role == 'admin' || role == 'entity'"
          >
            <v-list-item-avatar
              left
              v-if="urlLogo == null"
              size="100"
              color="indigo"
            >
              <v-icon
                class="pointer"
                size="100"
                @click="uploadFotoLogoVisible = true"
                dark
                >mdi-account-circle</v-icon
              >
            </v-list-item-avatar>
            <v-list-item-avatar left :rounded="true" size="100" v-else>
              <img
                class="pointer"
                @click="uploadFotoLogoVisible = true"
                :src="urlLogo"
                alt="Logo"
              />
            </v-list-item-avatar>
          </template>
          <template v-else>
            <v-list-item-avatar
              left
              v-if="urlLogo == null"
              size="100"
              color="indigo"
            >
              <v-icon size="100" dark>mdi-account-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-avatar left :rounded="true" size="100" v-else>
              <img :src="urlLogo" alt="Logo" />
            </v-list-item-avatar>
          </template>
          <!-- <v-list-item-avatar size="80" color="grey"></v-list-item-avatar> -->
        </v-list-item>
        <p class="mr-4 mb-1 caption text-right">
          Last Updated: {{ updatedAt }}
        </p>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <template
        v-if="role == 'super_admin' || role == 'admin' || role == 'entity'"
        v-slot:activator="{ on }"
      >
        <v-btn
          v-if="editedValue.name == ''"
          color="success"
          dark
          class="mt-5 ml-5"
          v-on="on"
          >Add Company Details</v-btn
        >
        <v-btn v-else color="success" dark class="mt-5 ml-5" v-on="on"
          ><v-icon>mdi-pencil</v-icon> Update Company Details</v-btn
        >
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="editedValue.owner_name"
                  label="Owner Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="editedValue.address"
                  label="Company Address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="editedValue.description"
                  label="Description"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  :type="'text'"
                  v-mask="'##.###.###.#-###.###'"
                  v-model="editedValue.company_number"
                  label="NPWP"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  :type="'text'"
                  v-mask="'###############'"
                  v-model="editedValue.telp"
                  label="Telp"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="12">
                <v-text-field v-model="editedValue.email" label="Email"></v-text-field>
              </v-col>-->
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadFotoLogoVisible" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Logo Perusahaan</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <template>
                <v-file-input
                  accept="image/*"
                  label="Upload/Update Logo"
                  v-model="fileLogo"
                ></v-file-input>
              </template>
              <v-btn
                text
                small
                v-if="urlLogo != null"
                @click="onRemoveImage('logo')"
                color="error"
                >Hapus Logo</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="[(uploadFotoLogoVisible = false), (fileLogo = null)]"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            v-if="fileLogo != null"
            text
            @click="onUploadLogo()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogInvoice" max-width="80%">
      <v-data-table :headers="invoiceHeaders" :items="invoice_items">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>List Invoice</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:[`item.no`]="props">
          {{ invoice_items.indexOf(props.item) + 1 + "." }}
        </template>
        <template v-slot:[`item.date`]="props">
          {{ parserDateOnly(props.item.date) }}
        </template>
        <template v-slot:[`item.amount`]="props">
          {{ convertCurrency(props.item.amount) }}
        </template>
        <template v-slot:[`item.status`]="props">
          <v-chip
            v-if="props.item.status === 'UNPAID'"
            label
            color="orange darken-2"
            class="mr-1"
            text-color="white"
          >
            {{ props.item.status }}
          </v-chip>
          <v-chip
            v-else
            label
            color="green darken-2"
            class="mr-1"
            text-color="white"
          >
            {{ props.item.status }}
          </v-chip>
        </template>
      </v-data-table>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { forEach, slice, isEmpty, orderBy, find, countBy } from "lodash";
import { formatCurrency } from "@/libs/number";
import dayjs from "dayjs";

export default {
  components: {},
  data: () => ({
    dialog: false,
    dialogInvoice: false,
    uploadFotoLogoVisible: false,
    role: "",
    updatedAt: "",
    editedValue: {
      name: "",
      description: "",
      owner_name: "",
      address: "",
      company_number: "",
      telp: "",
      email: "",
    },
    defaultValue: {
      name: "",
      description: "",
      owner_name: "",
      address: "",
      company_number: "",
      telp: "",
      email: "",
    },
    billingCounter: 0,
    urlNPWP: null,
    fileFotoNPWP: null,
    dataNPWP: null,
    urlAkta: null,
    fileAkta: null,
    dataAkta: null,
    urlSIUP: null,
    fileSIUP: null,
    dataSIUP: null,
    urlTDP: null,
    fileTDP: null,
    dataTDP: null,
    urlCompanyProfile: null,
    fileCompanyProfile: null,
    dataCompanyProfile: null,
    urlLogo: null,
    fileLogo: null,
    dataLogo: null,
    invoiceHeaders: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      {
        text: "Invoice",
        align: "left",
        value: "name",
      },
      {
        text: "Tanggal",
        align: "left",
        value: "date",
      },
      {
        text: "Jumlah",
        align: "left",
        value: "amount",
      },
      {
        text: "Status",
        align: "left",
        value: "status",
      },
    ],
    invoice_items: [],
  }),
  computed: {
    // ...mapGetters({
    //   getBillingCounter: "billing_counter/getBillingCounterByCompany"
    // }),
    ...mapState({
      companyData: (state) => state.company.companyData,
    }),
    formTitle() {
      return this.companyData == null
        ? "Add Company Details"
        : "Update Company Details";
    },
  },
  methods: {
    ...mapActions({
      getBillingCounter: "billing_counter/getBillingCounterByCompany",
      getInvoices: "billing_invoice/getInvoices",
      getCompany: "company/getCompany",
      updateCompany: "company/updateCompany",
      updateCompanyAttachment: "company/updateCompanyAttachment",
      createCompany: "company/createCompany",
      removeImage: "company/removeImage",
    }),
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    parserDateOnly(date) {
      return dayjs(date).format("DD-MM-YYYY");
    },
    async onUploadLogo() {
      if (this.fileLogo != null) {
        const data = new FormData();
        data.append("logo", this.fileLogo);
        data.append("id", this.defaultValue.id);
        data.append("name", this.defaultValue.name);
        data.append("owner_name", this.defaultValue.owner_name);
        data.append("address", this.defaultValue.address);

        const response = await this.updateCompanyAttachment({
          id: this.defaultValue.id,
          data: data,
        });
        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Update logo berhasil!",
          });
          this.dataLogo = find(
            response.data.attributes.company_attachment,
            (attachment) => attachment.attachment_type == "LOGO"
          );
          this.urlLogo =
            process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
            "/" +
            this.dataLogo.location +
            "/" +
            this.dataLogo.name;
          this.fileLogo = null;
          this.uploadFotoLogoVisible = false;
        }
      }
    },
    async onUploadImageNPWP() {
      if (this.fileFotoNPWP != null) {
        const data = new FormData();
        data.append("npwp", this.fileFotoNPWP);
        data.append("id", this.defaultValue.id);
        data.append("name", this.defaultValue.name);
        data.append("owner_name", this.defaultValue.owner_name);
        data.append("address", this.defaultValue.address);

        const response = await this.updateCompanyAttachment({
          id: this.defaultValue.id,
          data: data,
        });
        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Update foto NPWP berhasil!",
          });
          this.dataNPWP = find(
            response.data.attributes.company_attachment,
            (attachment) => attachment.attachment_type == "NPWP"
          );
          this.urlNPWP =
            process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
            "/" +
            this.dataNPWP.location +
            "/" +
            this.dataNPWP.name;
          this.fileFotoNPWP = null;
        }
      }
    },
    async onUploadAkta() {
      if (this.fileAkta != null) {
        const data = new FormData();
        data.append("akta", this.fileAkta);
        data.append("id", this.defaultValue.id);
        data.append("name", this.defaultValue.name);
        data.append("owner_name", this.defaultValue.owner_name);
        data.append("address", this.defaultValue.address);

        const response = await this.updateCompanyAttachment({
          id: this.defaultValue.id,
          data: data,
        });
        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Update dokumen akta berhasil!",
          });

          this.dataAkta = find(
            response.data.attributes.company_attachment,
            (attachment) => attachment.attachment_type == "AKTA"
          );
          this.urlAkta =
            process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
            "/" +
            this.dataAkta.location +
            "/" +
            this.dataAkta.name;
          this.fileAkta = null;
        }
      }
    },
    async onUploadSIUP() {
      if (this.fileSIUP != null) {
        const data = new FormData();
        data.append("siup", this.fileSIUP);
        data.append("id", this.defaultValue.id);
        data.append("name", this.defaultValue.name);
        data.append("owner_name", this.defaultValue.owner_name);
        data.append("address", this.defaultValue.address);

        const response = await this.updateCompanyAttachment({
          id: this.defaultValue.id,
          data: data,
        });
        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Update dokumen SIUP berhasil!",
          });

          this.dataSIUP = find(
            response.data.attributes.company_attachment,
            (attachment) => attachment.attachment_type == "SIUP"
          );
          this.urlSIUP =
            process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
            "/" +
            this.dataSIUP.location +
            "/" +
            this.dataSIUP.name;
          this.fileSIUP = null;
        }
      }
    },
    async onUploadTDP() {
      if (this.fileTDP != null) {
        const data = new FormData();
        data.append("tdp", this.fileTDP);
        data.append("id", this.defaultValue.id);
        data.append("name", this.defaultValue.name);
        data.append("owner_name", this.defaultValue.owner_name);
        data.append("address", this.defaultValue.address);

        const response = await this.updateCompanyAttachment({
          id: this.defaultValue.id,
          data: data,
        });
        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Update dokumen TDP berhasil!",
          });
          this.dataTDP = find(
            response.data.attributes.company_attachment,
            (attachment) => attachment.attachment_type == "TDP"
          );
          this.urlTDP =
            process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
            "/" +
            this.dataTDP.location +
            "/" +
            this.dataTDP.name;
          this.fileTDP = null;
        }
      }
    },
    async onUploadCompanyProfile() {
      if (this.fileCompanyProfile != null) {
        const data = new FormData();
        data.append("company_profile", this.fileCompanyProfile);
        data.append("id", this.defaultValue.id);
        data.append("name", this.defaultValue.name);
        data.append("owner_name", this.defaultValue.owner_name);
        data.append("address", this.defaultValue.address);

        const response = await this.updateCompanyAttachment({
          id: this.defaultValue.id,
          data: data,
        });
        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Update dokumen Company Profile berhasil!",
          });
          this.dataCompanyProfile = find(
            response.data.attributes.company_attachment,
            (attachment) => attachment.attachment_type == "COMPANY_PROFILE"
          );
          this.urlCompanyProfile =
            process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
            "/" +
            this.dataCompanyProfile.location +
            "/" +
            this.dataCompanyProfile.name;
          this.fileCompanyProfile = null;
        }
      }
    },
    async onRemoveImage(type) {
      try {
        let id;

        if (type == "logo") {
          id = this.dataLogo.id;
        } else if (type == "npwp") {
          id = this.dataNPWP.id;
        } else if (type == "siup") {
          id = this.dataSIUP.id;
        } else if (type == "tdp") {
          id = this.dataTDP.id;
        } else if (type == "akta") {
          id = this.dataAkta.id;
        } else if (type == "company profile") {
          id = this.dataCompanyProfile.id;
        }

        const response = await this.removeImage(id);
        if (response.status === 200) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Hapus " + type + " berhasil!",
          });

          if (type == "logo") {
            this.urlLogo = null;
            this.dataLogo = null;
            this.fileLogo = null;
            this.uploadFotoLogoVisible = false;
          } else if (type == "npwp") {
            this.urlNPWP = null;
            this.dataNPWP = null;
          } else if (type == "siup") {
            this.urlSIUP = null;
            this.dataSIUP = null;
          } else if (type == "tdp") {
            this.urlTDP = null;
            this.dataTDP = null;
          } else if (type == "akta") {
            this.urlAkta = null;
            this.dataAkta = null;
          } else if (type == "company profile") {
            this.urlCompanyProfile = null;
            this.dataCompanyProfile = null;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async save() {
      if (this.companyData != null) {
        try {
          const response = await this.updateCompany({
            id: this.defaultValue.id,
            data: this.editedValue,
          });
          if (response.data.success) {
            this.defaultValue = Object.assign({}, this.editedValue);
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Success update Company details!",
            });
          } else {
            this.editedValue = Object.assign({}, this.companyData);
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          let updateLocalStorage = JSON.parse(
            window.localStorage.getItem("user_data")
          );
          this.editedValue.name = updateLocalStorage.name;
          this.editedValue.email = updateLocalStorage.email;
          const response = await this.createCompany(this.editedValue);
          if (response.data.success) {
            // console.log(response)
            updateLocalStorage.company_id = response.data.attributes.id;
            alert("Company details added!");
            window.localStorage.setItem(
              "user_data",
              JSON.stringify(updateLocalStorage)
            );
            window.location.reload(true);
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Success create Company!",
            });
          } else {
            this.editedValue = Object.assign({}, this.companyData);
          }
        } catch (e) {
          console.log(e);
        }
      }
      this.dialog = false;
    },
    async close() {
      if (this.companyData != null) {
        this.editedValue = Object.assign({}, this.companyData);
      } else {
        this.editedValue = Object.assign({}, this.defaultValue);
      }
      this.dialog = false;
    },
    async detailInvoice() {
      this.invoice_items = [];
      const response = await this.getInvoices();
      forEach(response, (data) => {
        if (data.entity_id === null) {
          data.amount = Number(data.amount);
          this.invoice_items.push(data);
        }
      });
      this.dialogInvoice = true;
    },
  },
  async mounted() {
    // console.log(this.editedValue)
    // const foundBillingCounter = await this.getBillingCounter;
  },
  async created() {
    const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
    this.role = userLogin.roles[0].name;
    const response = await this.getCompany();
    const foundBillingCounter = await this.getBillingCounter({
      company_id: this.companyData.id,
    });
    if (foundBillingCounter) {
      this.billingCounter = foundBillingCounter.amount;
    }
    // this.billingCounter = foundBillingCounter;
    forEach(response.data.attributes.company_attachment, (attachment) => {
      if (attachment.attachment_type == "AKTA") {
        this.urlAkta =
          process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
          "/" +
          attachment.location +
          "/" +
          attachment.name;
        this.dataAkta = attachment;
      } else if (attachment.attachment_type == "SIUP") {
        this.urlSIUP =
          process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
          "/" +
          attachment.location +
          "/" +
          attachment.name;
        this.dataSIUP = attachment;
      } else if (attachment.attachment_type == "TDP") {
        this.urlTDP =
          process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
          "/" +
          attachment.location +
          "/" +
          attachment.name;
        this.dataTDP = attachment;
      } else if (attachment.attachment_type == "NPWP") {
        this.urlNPWP =
          process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
          "/" +
          attachment.location +
          "/" +
          attachment.name;
        this.dataNPWP = attachment;
      } else if (attachment.attachment_type == "COMPANY_PROFILE") {
        this.urlCompanyProfile =
          process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
          "/" +
          attachment.location +
          "/" +
          attachment.name;
        this.dataCompanyProfile = attachment;
      } else if (attachment.attachment_type == "LOGO") {
        this.urlLogo =
          process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL +
          "/" +
          attachment.location +
          "/" +
          attachment.name;
        this.dataLogo = attachment;
      }
    });

    this.editedValue = isEmpty(this.companyData)
      ? this.editedValue
      : Object.assign({}, this.companyData);
    this.defaultValue = Object.assign({}, this.editedValue);
    let myDate = new Date(this.defaultValue.updated_at);
    myDate.setHours(myDate.getHours() + 7);
    this.updatedAt = myDate
      .toString()
      .replace(" GMT+0700 (Western Indonesia Time)", "");
  },
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
.v-input
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input::-webkit-outer-spin-button,
.v-input
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* this is for Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.pointer {
  cursor: pointer;
}
</style>
